import { prefillForm, saveFormDataLocally } from "./lib/form-prefill";
import { initCloudflareEnrichment } from "./marketo-form-to-rest-api-v2";

const prefill = () => {
  const form = /** @type {HTMLFormElement | null} */ (
    document.getElementById("mkto-api-form")
  );
  if (form) {
    // Pre-fill form if form data is available and valid
    prefillForm(form);
  }
  // Enrich with Cloudflare data
  initCloudflareEnrichment();

  const handleFormSubmit = () => {
    if (!form) return;
    // Save form data in local storage
    saveFormDataLocally(form);
  };
  form?.addEventListener("submit", handleFormSubmit);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", prefill);
} else {
  prefill();
}
